import { render, staticRenderFns } from "./BigScreenMonitor.vue?vue&type=template&id=5b517dce&scoped=true"
import script from "./BigScreenMonitor.vue?vue&type=script&lang=js"
export * from "./BigScreenMonitor.vue?vue&type=script&lang=js"
import style0 from "./BigScreenMonitor.vue?vue&type=style&index=0&id=5b517dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b517dce",
  null
  
)

export default component.exports